import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';

import { Text } from './text';
import { colors } from '../styles';

const propTypes = {
  className: PropTypes.string,
  image: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired
};

/**
 * Renders an avatar icon, name, and title.
 * If no image is provided, renders a placehodler circle containing the first initial of the name.
 *
 * @component
 * @param {object} props
 * @prop {object} image the image object for the avatar image
 * @prop {string} name the name of the person in the avatar
 * @prop {string} title the title of the person in the avatar
 */
const Avatar = props => {
  const { className, image, name, title } = props;

  return (
    <AuthorWrapper className={className}>
      <AvatarWrapper>
        {image?.fluid ? (
          <AvatarImg image={image.fluid} alt={name}></AvatarImg>
        ) : (
          <AvatarPlaceholder>{name?.[0]}</AvatarPlaceholder>
        )}
      </AvatarWrapper>
      <AuthorText>
        {name}
        {title && <span style={{ display: 'block' }}>{title}</span>}
      </AuthorText>
    </AuthorWrapper>
  );
};

const AuthorWrapper = styled.div`
  display: flex;
  margin-top: 40px;
`;

const AvatarWrapper = styled.div`
  position: relative;
  align-self: center;
  height: 60px;
  margin-right: 10px;
`;

const AvatarImg = styled(GatsbyImage)`
  width: 60px;
  height: 60px;
  margin-right: 8px;
  margin-bottom: 0;
  border-radius: 100%;

  img {
    margin-bottom: 0;
  }
`;

const AuthorText = styled(Text)`
  align-self: center;
`;

const AvatarPlaceholder = styled.div`
  width: 60px;
  height: 60px;
  margin-right: 8px;
  margin-bottom: 0;
  border-radius: 100%;
  background-color: ${colors.oceanBlue};
  color: ${colors.pureWhite};
  text-transform: uppercase;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;

Avatar.propTypes = propTypes;

export { Avatar };
